// TODO: use these when pages/routes are ready
const TRAINING = {
    COURSE_CATALOG: {
        RESOURCE_ID: 'trainingCourseCatalog',
    },
    MY_COURSES: {
        RESOURCE_ID: 'trainingMyCourses',
    },
    TRACK_DASHBOARD: {
        RESOURCE_ID: 'trainingTrackDashboard',
    },
    SAFETY_COURSES: {
        RESOURCE_ID: 'trainingSafetyCourses',
    },
    MY_CERTIFICATES: {
        RESOURCE_ID: 'trainingMyCertificates',
    },
    TRACK: {
        RESOURCE_ID: 'trainingTrack',
    },
    TRACK_ADD: {
        RESOURCE_ID: 'trainingTrackAdd',
    },
    TRACK_EDIT: {
        RESOURCE_ID: 'trainingTrackEdit',
    },
    TRACK_EMPLOYEES: {
        RESOURCE_ID: 'trainingTrackEmployees',
    },
    USER_PROGRESS: {
        RESOURCE_ID: 'trainingUserProgress',
    },
    FORCE_COURSE_COMPLETION: {
        RESOURCE_ID: 'trainingForceCourseCompletion',
    },
    PACKAGES: {
        RESOURCE_ID: 'trainingPackages',
    },
    DASHBOARD_REPORT: {
        RESOURCE_ID: 'trainingDashboardReport',
    },
    TOOLS: {
        RESOURCE_ID: 'trainingTools',
    },
    USER_ACTIVITY_REPORT: {
        RESOURCE_ID: 'trainingUserActivityReport',
    },
};

export default TRAINING;
